import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { useDispatch } from "react-redux";
import {
  Divider,
  Form,
  Input,
  Row,
  Col,
  Button,
  Spin,
  Select,
  message,
} from "antd";

import { map } from "lodash";
import { fetchCompanyParts } from "../../redux/actions/companyActions";
import {
  createProductionComponents,
  updateProductionComponents,
} from "../../redux/actions/productionCompActions";
import {
  ADD_PRODUCTION_COMPONENT_SUCCESS,
  UPDATE_PRODUCTION_COMPONENT_SUCCESS,
} from "../../constants/message";

const ProductionComponentForm = ({
  toggle,
  initialValue,
  filter,
  setConfig,
  config,
  setFilters,
  setTemplateType
}) => {
  const dispatch = useDispatch();
  const isEdit = get(initialValue,"name") ? true : false;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const produtionCompid = get(initialValue, "id");
  const companyid = get(filter, "company.id");

  const getCompanyParts = (value) => {
    setLoading(true);
    setFilters((filter) => ({
      ...filter,
      templateType: value,
    }));
    const query = { type: value };
    dispatch(fetchCompanyParts(get(filter, "company.id"), query))
      .then((parts) => {
        setConfig({
          ...config,
          parts,
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const validateSameCycleTime = (_, selectedPartIds) => {
    if (!selectedPartIds || selectedPartIds.length <= 1) {
      return Promise.resolve(); 
    }

    const availableParts = get(config, "parts", []);
    const selectedParts = availableParts.filter(part =>
      selectedPartIds.includes(get(part, "id"))
    );

    if (selectedParts.length !== selectedPartIds.length) {
      return Promise.reject(new Error("Selected part not found in available parts."));
    }

    const firstCycleTime = get(selectedParts[0], "meta.cycle_time");

    const allSameCycleTime = selectedParts.every(part =>
      get(part, "meta.cycle_time") === firstCycleTime
    );

    if (allSameCycleTime) {
      return Promise.resolve();
    }
    
    const cycleTimeMissing = selectedParts.some(part => !get(part, "meta.cycle_time"));
    if (cycleTimeMissing) {
        return Promise.reject(new Error("One or more selected parts are missing cycle time data."));
    }

    return Promise.reject(new Error("All selected parts must have the same cycle time."));
  };

  const onUpdate = (payload) => {
    setLoading(true);
    dispatch(updateProductionComponents(companyid, produtionCompid, payload))
      .then(() => {
        setLoading(false);
        message.success(UPDATE_PRODUCTION_COMPONENT_SUCCESS);
        toggle();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onCreate = (payload) => {
    setLoading(true);
    dispatch(createProductionComponents(companyid, payload))
      .then(() => {
        setLoading(false);
        message.success(ADD_PRODUCTION_COMPONENT_SUCCESS);
        toggle();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    setTemplateType(undefined)
    const payload = {
      ...values,
      parts:get(values, "parts",[])
    };
    if (isEdit) {
      onUpdate(payload);
    } else {
      onCreate(payload);
    }
  };
useEffect(()=>{
  if(get(initialValue,"type.value")){
    getCompanyParts(get(initialValue,"type.value"))
  }
},[initialValue])
  return (
    <Spin spinning={loading}>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFinishFailed={() => { }}
        initialValues={{
          ...initialValue,
          Company: get(filter, "company.id"),
          parts: initialValue
            ? map(get(initialValue, "parts", []), (part) => get(part, "id"))
            : undefined,
          type: get(initialValue, "type.value", undefined),
        }}
      >
        <Divider />
        <Row gutter={16}>
          <Col md={12} xs={24}>
            <Form.Item
              name={"Company"}
              label={`Company`}
              rules={[{ required: true, message: "Please Select Company" }]}
            >
              <Select
                options={map(get(config, "companies"), (company) => ({
                  label: get(company, "name"),
                  value: get(company, "id"),
                }))}
                value={get(filter, "company.id")}
                placeholder="Select Company"
                disabled
                optionFilterProp="label"
                showSearch
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name={"type"}
              label={`Template Type`}
              rules={[
                { required: true, message: "Please Select Template Type" },
              ]}
            >
              <Select
                options={map(
                  get(config, "template_types"),
                  (templateType) => ({
                    label: get(templateType, "name"),
                    value: get(templateType, "value"),
                  })
                )}
                disabled={get(initialValue, "type.value")}
                onChange={(value) => {
                  getCompanyParts(value);
                  form.setFieldsValue({
                    parts:[]
                  })
                }}
                placeholder="Select Template Type"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24}>
            <Form.Item
              name="name"
              label="Name"
              colon={false}
              layout="vertical"
              rules={[{ required: true, message: "Please Input Name" }]}
            >
              <Input size="middle" placeholder="Name" />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item
              name="serial_number"
              label="Die/Tool/Serial No"
              colon={false}
              layout="vertical"
            >
              <Input placeholder="Die/Tool/Serial No" />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item
              name="parts"
              label="Parts"
              colon={false}
              layout="vertical"
              rules={[
                { validator: validateSameCycleTime }
              ]}
            >
              <Select
                style={{ minWidth: 200 }}
                mode="multiple"
                size="middle"
                showSearch
                placeholder="Select Parts"
                options={map(get(config, "parts"), (part) => ({
                  label: `${get(part, "name")} ${get(part, "meta.cycle_time")?`[CT-${get(part, "meta.cycle_time")}]`:""}`,
                  value: get(part, "id"),
                }))}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <div className="w-full bg-white p-4">
          <div className="flex justify-end space-x-2">
            <Button
              onClick={() => {
                toggle();
              }}
              className="border-gray-300"
            >
              Close
            </Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </div>
      </Form>
    </Spin>
  );
};

export default ProductionComponentForm;
